import { render, staticRenderFns } from "./CustomIconComponent.vue?vue&type=template&id=3a169402&"
import script from "./CustomIconComponent.vue?vue&type=script&lang=js&"
export * from "./CustomIconComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports